import React from 'react';
import styles from '../ReportCard.module.scss';
import moment from 'moment';

const Last3Marks = ({ loads, loading }) => {
  if (loading) {
    return <div className={styles.loadingText}>Загрузка последних отметок...</div>;
  }

  if (!loads || loads.length === 0) {
    return <div className={styles.emptyText}>Нет последних отметок</div>;
  }

  const formatDateTime = (dateString) => {
    if (!dateString) return '-';
    // Сначала пробуем распарсить как DD.MM.YYYY HH:mm
    let date = moment(dateString, 'DD.MM.YYYY HH:mm', true);
    if (!date.isValid()) {
      // Если не получилось, пробуем ISO формат
      date = moment(dateString);
      if (date.isValid()) {
        return date.format('DD.MM.YYYY HH:mm');
      }
      return dateString; // Вернем как есть, если не смогли распарсить
    }
    return dateString; // Уже в нужном формате
  };

  const formatDateTimeWithRelative = (dateString) => {
    if (!dateString) return '-';
    // Парсим дату
    let date = moment(dateString, 'DD.MM.YYYY HH:mm', true);
    if (!date.isValid()) {
      date = moment(dateString);
    }
    if (!date.isValid()) return dateString;

    const now = moment();
    const minutesAgo = now.diff(date, 'minutes');
    
    if (minutesAgo < 20) {
      // Показываем "X мин назад"
      return `${date.format('DD.MM.YYYY HH:mm')} — ${minutesAgo} мин назад`;
    } else {
      // Показываем только дату и время
      return date.format('DD.MM.YYYY HH:mm');
    }
  };

  const formatDuration = (durationStr) => {
    if (!durationStr) return '-';
    return durationStr;
  };

  const getStatusColor = (status) => {
    if (status === 'В погрузке') return '#FF9800';
    if (status === 'В пути' || status === 'Въехал в точку А') return '#2196F3';
    if (status === 'Завершено' || status === 'Въехал в точку Б') return '#4CAF50';
    return '#6c757d';
  };

  return (
    <div className={styles.last3MarksContainer}>
      {loads.slice(0, 3).map((load, idx) => {
        const driverName = load.employee_name || '-';
        const vehicleNumber = load.vehicle_number || '-';
        const baseName = load.top_base_name || load.chpp_name || load.private_point_name || '-';
        const status = load.status || '-';
        const timeAExit = formatDateTime(load.time_a_exit);
        const timeB = formatDateTime(load.time_b);
        const loadingTime = formatDuration(load.duration_str_loading);
        const deliveryTime = formatDuration(load.duration_str);

        return (
          <div key={load.id} className={styles.markCard}>
            <div className={styles.markHeader} style={{ background: `linear-gradient(135deg, ${getStatusColor(status)} 0%, ${getStatusColor(status)}dd 100%)` }}>
              <div className={styles.markNumber}>#{idx + 1}</div>
              <div className={styles.markStatus}>{status}</div>
            </div>
            <div className={styles.markBody}>
              <div className={styles.markRow}>
                <span className={styles.markLabel}>Водитель:</span>
                <span className={styles.markValue}>{driverName}</span>
              </div>
              <div className={styles.markRow}>
                <span className={styles.markLabel}>Машина:</span>
                <span className={styles.markValue}>{vehicleNumber}</span>
              </div>
              <div className={styles.markRow}>
                <span className={styles.markLabel}>База:</span>
                <span className={styles.markValue}>{baseName}</span>
              </div>
              {status === 'В погрузке' ? (
                <div className={styles.markRow}>
                  <span className={styles.markLabel}>Время создания:</span>
                  <span className={styles.markValue}>{formatDateTimeWithRelative(load.created_at)}</span>
                </div>
              ) : (
                <div className={styles.markRow}>
                  <span className={styles.markLabel}>Въезд (Кара-Кече):</span>
                  <span className={styles.markValue}>{formatDateTimeWithRelative(load.time_a)}</span>
                </div>
              )}
              {timeAExit && timeAExit !== '-' && (
                <>
                  <div className={styles.markRow}>
                    <span className={styles.markLabel}>Выезд (Кара-Кече):</span>
                    <span className={styles.markValue}>{timeAExit}</span>
                  </div>
                  <div className={styles.markRow}>
                    <span className={styles.markLabel}>Время погрузки:</span>
                    <span className={styles.markValue}>{loadingTime}</span>
                  </div>
                </>
              )}
              {timeB && timeB !== '-' && (
                <>
                  <div className={styles.markRow}>
                    <span className={styles.markLabel}>Прибытие на базу:</span>
                    <span className={styles.markValue}>{timeB}</span>
                  </div>
                  <div className={styles.markRow}>
                    <span className={styles.markLabel}>Время доставки:</span>
                    <span className={styles.markValue}>{deliveryTime}</span>
                  </div>
                </>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Last3Marks;
